export default __webpack_public_path__ + "static/media/lynnGame1.eba812fd.png";